import React from "react";
import Paper from "material-ui/Paper";
import Grid from "material-ui/Grid";
import Typography from "material-ui/Typography";
import Card, { CardContent } from "material-ui/Card";
import ReactSpeedometer from "react-d3-speedometer";
import { withStyles } from "material-ui/styles";
import styles from "./styles";

class UptimeSubtest extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    const {
      classes,
      translate,
      results,
      chartMeasurementUnit,
      subtestResultsDisplay,
      subtest,
      subtestRes
    } = this.props;

    return (
      results.data.subtests[subtest] && (
        <Grid container spacing={0}>
          <Grid xs={12} className={classes.topGrid}>
            <Typography className={classes.t_tar_text}>
              {translate("result_test_duration2").toUpperCase()}
            </Typography>
            <Typography className={classes.t_tar_no}>
              {results.data.subtests[subtest].duration
                ? results.data.subtests[subtest].duration
                : ""}
            </Typography>
          </Grid>
          <Grid xs={12} className={classes.bottomGrid}>
            <div className={classes.gauge}>
              <ReactSpeedometer
                ringWidth={20}
                needleHeightRatio={0.5}
                segments={3}
                maxValue={100}
                value={results.data.subtests[subtest].efficiency}
                segmentColors={["#d6d4d4", "#d6d4d4", "#d6d4d4"]}
                needleColor="#000000"
                textColor={"#000000"}
                fluidWidth={true}
                currentValueText="."
              />
            </div>
            <Typography color="inherit" className={classes.t_tar_no2}>
              {translate("result_efficiency")}
            </Typography>
            <Typography color="inherit" className={classes.t_tar_no2}>
              {results.data.subtests[subtest] &&
                results.data.subtests[subtest].efficiency.toFixed(3) + "%"}
            </Typography>
          </Grid>
        </Grid>
      )
    );
  }
}

export default withStyles(styles)(UptimeSubtest);
